import { type ReactNode } from "react";

interface Column {
  header: string;
  key: string;
  render?: (value: any, row: any) => ReactNode;
}

interface TableProps {
  columns: Column[];
  data: any[];
}

export default function Table({ columns, data }: TableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-[0.78rem]">
        <thead className="bg-white/[0.02]">
          <tr>
            {columns.map((col, idx) => (
              <th
                key={idx}
                className="px-1.5 py-2 text-left whitespace-nowrap font-medium text-text-soft border-b border-border-soft text-[0.74rem]"
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data && data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="px-1.5 py-2 text-center text-text-soft"
              >
                Nenhuma consulta a decorrer no momento.
              </td>
            </tr>
          ) : (
            data.map((row, rowIdx) => (
              <tr
                key={rowIdx}
                className="border-b border-white/[0.02] hover:bg-white/[0.02]"
              >
                {columns.map((col, colIdx) => (
                  <td key={colIdx} className="px-1.5 py-2 whitespace-nowrap">
                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export function Badge({
  children,
  variant = "default",
}: {
  children: ReactNode;
  variant?: "default" | "success" | "warning" | "danger";
}) {
  const variantClasses = {
    default: "bg-white/[0.04] text-text-soft",
    success: "bg-success/[0.16] text-success",
    warning: "bg-yellow-500/[0.16] text-yellow-400",
    danger: "bg-danger/[0.16] text-danger",
  };

  return (
    <span
      className={`px-2 py-0.5 rounded-full text-[0.7rem] ${variantClasses[variant]}`}
    >
      {children}
    </span>
  );
}

export function TableLink({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) {
  return (
    <span
      onClick={onClick}
      className="text-[0.7rem] text-accent cursor-pointer hover:underline"
    >
      {children}
    </span>
  );
}
